import axios from "axios";
import { BASE_API_URL } from "../utils/api-url";

export async function passwordRecovery(email) {
  try {
    const result = await axios({
      method: "POST",
      url: `${BASE_API_URL}/recoverPassword`,
      data: { email },
    });
  
    return result.data;
  } catch (error) {
    return error
  }
}

export async function resetPassword(data) {
  try {
    const result = await axios({
      method: "POST",
      url: `${BASE_API_URL}/resetPassword`,
      data,
    });
  
    return result.data;
  } catch (error) {
    return error
  }
}